import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const QuickActionButton = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isPressed, setIsPressed] = useState(false);

  const getActionConfig = () => {
    if (location?.pathname === '/active-workout') {
      return {
        icon: 'Plus',
        label: 'Log Exercise',
        action: () => {},
        ariaLabel: 'Log completed exercise'
      };
    }

    if (location?.pathname === '/login' || location?.pathname === '/register') {
      return null;
    }

    return {
      icon: 'Play',
      label: 'Start Workout',
      action: () => navigate('/workout-library'),
      ariaLabel: 'Start a new workout session'
    };
  };

  const config = getActionConfig();

  if (!config) return null;

  const handleClick = () => {
    setIsPressed(true);
    config?.action();
    setTimeout(() => setIsPressed(false), 400);
  };

  return (
    <button
      onClick={handleClick}
      className={`
        fixed bottom-20 right-6 lg:bottom-8 lg:right-8 z-[90]
        flex items-center gap-3 h-14 lg:h-16 px-6 lg:px-8
        bg-accent text-accent-foreground rounded-full shadow-xl
        transition-smooth hover-lift press-scale
        ${isPressed ? 'transition-spring scale-110' : ''}
      `}
      aria-label={config?.ariaLabel}
    >
      <Icon 
        name={config?.icon} 
        size={24} 
        color="var(--color-accent-foreground)"
        strokeWidth={2.5}
      />
      <span className="font-heading font-semibold text-base lg:text-lg">
        {config?.label}
      </span>
    </button>
  );
};

export default QuickActionButton;